import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import VietradeBody from '../components/VietradeBody'

const HomePage = () => {
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col overflow-hidden'>
      <Header/>
      <VietradeBody/>
      <Footer/>
    </div>
  )
}

export default HomePage